
function Cancel() {
  return <div>Cancel-payments</div>;
}

export default Cancel;
